import { useState } from 'react'
import { showErrorSnackbar } from '../../../components/snackbar/Snackbar'
import { messages } from '../../../constants/strings/messages'
import { Installment } from '../../../services/main/updateBankSlip'
import { usePromise } from '../../../utils/hooks/usePromise'
import { updateManyBankSlips } from '../../../services/main/updateManyBankSlips'
import { getManyUrlsAndBarCodeBankSlips } from '../../../services/main/getManyUrlAndBarCodeBankSlips'
import { addManySecondBankSlip } from './saveQuantityBankSlip'
import { formatMessage } from '../../../constants/strings/intl/intlHooks'
import { getInstallmentDateAndTypeLabel } from '../constants'

const TIME_IN_MILLISECONDS = 5000

export const useGetManySecondBankSlip = (callbackSuccess?: (installment?: any) => void | Promise<any>) => {
  const [awaitGetBarcode, setAwaitGetBarCode] = useState(false)

  const getAwaitGetBarcodeBankSlip = (installments: Installment[]) => {
    setTimeout(() => getBarcodeBankSlip(installments), TIME_IN_MILLISECONDS)
  }

  const showError = (date?: string) => {
    if (date) {
      return showErrorSnackbar(formatMessage(messages.financeScreen_error_second_bank_slips, { date }))
    }
    return showErrorSnackbar(formatMessage(messages.financeScreen_error_second_bank_slip))
  }

  const { loading: isGetDuplicateBankSlipLoading, request: getManyDuplicateBankSlip } = usePromise(
    updateManyBankSlips,
    [],
    {
      onSuccess: installments => {
        setAwaitGetBarCode(true)
        getAwaitGetBarcodeBankSlip(installments)
      },
      onError: () => {
        setAwaitGetBarCode(false)
        showError()
      },
    }
  )
  const { loading: isGetBarcodeLoading, request: getBarcodeBankSlip } = usePromise(getManyUrlsAndBarCodeBankSlips, [], {
    onSuccess: async results => {
      const failResults = []
      const successResults = []
      results.forEach(result => {
        if (!result.success) {
          failResults.push(result)
          return
        }
        successResults.push(result)
      })
      if (failResults.length) {
        const dates = montErrorMessage(failResults)
        dates && showError(dates)
      }
      if (successResults.length) {
        addManySecondBankSlip(successResults)
        await callbackSuccess?.(successResults[0].installment)
      }
      setAwaitGetBarCode(false)
    },
  })

  return {
    getManyDuplicateBankSlip,
    loadingBankSlip: isGetDuplicateBankSlipLoading || isGetBarcodeLoading || awaitGetBarcode,
  }
}

const montErrorMessage = (results: { installment: Installment; success: boolean }[]) => {
  const date = results.map(result => getInstallmentDateAndTypeLabel(new Date(result?.installment?.dueDate)))
  return date.toString()
}
